


































import { cancelfollowApi } from "@/api/studentFollow";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() logId!: number;
  form: any = {};
  dialogVisible: boolean = false;
  openDialog() {
    this.dialogVisible = true;
  }
  handleClose() {
    this.dialogVisible = false;
  }
  handleSubmit() {
    cancelfollowApi({
      follow_id: this.logId,
      cancel_remark: this.form.remark,
    }).then(() => {
      this.$message({
        type: "success",
        message: "取消成功",
      });
      this.$emit("change");
      this.handleClose();
    });
  }
}
